module.exports = __webpack_public_path__ + "static/gem-visa-home-hero-cf7af691923db3a926b67026b3e89fed.png";